/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-action-documents': {
    width: 10,
    height: 9,
    viewBox: '0 0 10 9',
    data: '<defs><path pid="0" d="M3.363 1.28h5.809c.456 0 .828.396.828.916L9.703 7.61c0 .492-.372.888-.828.888h-7.75c-.456 0-.829-.396-.828-.863L0 1.204C0 .712.372.316.828.316H2.24c.116 0 .228.048.313.134l.81.83zm-1.305.016H.914L1.2 7.518H8.8l.287-5.258H3.182a.437.437 0 0 1-.313-.135l-.81-.829zm7.488 1.978v.98H.454v-.98h9.092z" id="svgicon-icon-action-documents-a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon-icon-action-documents-b" _fill="#fff"><use xlink:href="#svgicon-icon-action-documents-a"/></mask><use _fill="#376F99" fill-rule="nonzero" xlink:href="#svgicon-icon-action-documents-a"/><path pid="1" _fill="#376F99" mask="url(#svgicon-icon-action-documents-b)" d="M0-.593h10v10H0z"/></g>'
  }
})
